import { render, staticRenderFns } from "./OldUnion.vue?vue&type=template&id=9fa92874&scoped=true&"
import script from "./OldUnion.vue?vue&type=script&lang=js&"
export * from "./OldUnion.vue?vue&type=script&lang=js&"
import style0 from "./OldUnion.vue?vue&type=style&index=0&id=9fa92874&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa92874",
  null
  
)

export default component.exports